import { IComponentLink } from '../component';

// 相同弹窗图片共享记录，兼容旧版保存的过期时间。
export function consumeModalAutoDisplay(link: IComponentLink): boolean {
  if (!link.modalauto || !link.modalcontent) {
    return false;
  }

  try {
    const key = `modal_content_${link.modalcontent}`;
    const previous = window.localStorage.getItem(key);
    if (previous && Number(previous) > Date.now()) {
      return false;
    }

    const nextDay = new Date();
    nextDay.setHours(24, 0, 0, 0);
    // 默认沿用原有的 24 小时间隔；开启每天弹一次时，在本地次日零点重置。
    const expiresAt = link.modaldaily ? nextDay.getTime() : Date.now() + 86400 * 1000;
    window.localStorage.setItem(key, String(expiresAt));
    return true;
  } catch (error) {
    // 无法记录展示状态时不自动弹出，避免反复打扰用户；手动点击仍可打开。
    return false;
  }
}
